export const MESSAGE_EDIT_ERROR = "Could not save your changes. Please try again.";
export const MESSAGE_DELETE_ERROR = "Could not delete. Please try again.";
export const MESSAGE_GONE_ERROR = "This comment no longer exists.";
export const MESSAGE_TOO_LONG_ERROR = "This message is too long. Shorten it and try again.";

export function deleteConfirmCopy({
  isReply,
  isInternal,
  replyCount,
}: {
  isReply: boolean;
  isInternal?: boolean;
  replyCount: number;
}): { title: string; description: string } {
  const noun = isInternal ? "internal note" : "comment";

  const tail = "will be permanently deleted, along with any attached files. This can't be undone.";

  if (isReply) {
    return {
      title: "Delete reply?",
      description: `This reply ${tail}`,
    };
  }
  if (replyCount < 1) {
    return {
      title: `Delete ${noun}?`,
      description: `This ${noun} ${tail}`,
    };
  }
  const replies = replyCount === 1 ? "the reply under it" : `all ${replyCount} replies under it`;
  return {
    title: `Delete ${noun} and all replies?`,
    description: `This ${noun} and ${replies} ${tail}`,
  };
}
